import { skipToken } from '@reduxjs/toolkit/query'
import { ROUTE_PATHS } from 'core/constants/routePath'
import {
  useCreateUpdatePromptMutation,
  useDeletePromptMutation,
  useGetPromptQuery,
} from 'lauria/api/prompt'
import { useGetAllPromptHistorisesQuery } from 'lauria/api/promptHistorise'
import { promptLayout } from 'lauria/store/slices/promptLayout'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { generatePath, useNavigate } from 'react-router'

export const usePromptContent = (
  promptId: number | null,
  refetchPrompts: () => {}
) => {
  const {
    data: prompt,
    isLoading: isLoadingPrompt,
    isFetching: isFetchingPrompt,
    refetch: refetchPrompt,
  } = useGetPromptQuery(promptId ? { promptId } : skipToken)
  const [openRemoveModal, setOpenRemoveModal] = useState(false)
  const [openHistoryModal, setOpenHistoryModal] = useState(false)
  const [openChangeStatusModal, setOpenChangeStatusModal] = useState(false)

  const {
    data: promptHistorises,
    isLoading: isLoadingPromptHistorises,
    refetch: refetchPromptHistorises,
  } = useGetAllPromptHistorisesQuery(
    { promptId: promptId ?? 0 },
    { skip: !openHistoryModal || promptId == null }
  )

  useEffect(() => {
    if (openHistoryModal) refetchPromptHistorises()
  }, [openHistoryModal, refetchPromptHistorises])

  const [deletePrompt, { isLoading: isDeleting }] = useDeletePromptMutation()
  const navigate = useNavigate()
  const { application } = useSelector(promptLayout)
  const [createUpdatePrompt, { isLoading: isUpdating }] =
    useCreateUpdatePromptMutation()
  const changeStatus = () => {
    if (prompt) {
      const formData = new FormData()
      formData.append('actif', !prompt.actif ? 'true' : 'false')
      formData.append('idPrompt', prompt.id.toString())
      createUpdatePrompt({ data: formData })
        .unwrap()
        .then(() => {
          refetchPrompt()
          refetchPrompts()
          setOpenChangeStatusModal(false)
        })
    }
  }
  const handleAppClick = () => {
    navigate(
      generatePath(ROUTE_PATHS.PROMPT_EDIT, {
        idApplication: application?.id,
        idPrompt: prompt?.id,
      })
    )
  }

  const handleDelete = () => {
    if (prompt) {
      deletePrompt(prompt.id)
        .unwrap()
        .then(() => {
          refetchPrompts()
          setOpenRemoveModal(false)
        })
    }
  }

  return {
    changeStatus,
    handleAppClick,
    openRemoveModal,
    setOpenRemoveModal,
    openChangeStatusModal,
    setOpenChangeStatusModal,
    isUpdating,
    isLoading: isLoadingPrompt || isFetchingPrompt,
    prompt,
    handleDelete,
    isDeleting,
    setOpenHistoryModal,
    openHistoryModal,
    promptHistorises,
    isLoadingPromptHistorises,
  }
}
